import React, { useState, useEffect, useRef } from 'react';
import '../../../../styles/ReviewImageViewer.scss';

interface ReviewImage {
  id: string;
  media_url: string;
}

interface Props {
  images: ReviewImage[];
}

const ReviewImageViewer: React.FC<Props> = ({ images }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStartX = useRef<number | null>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!isModalOpen) return;

      if (e.key === 'ArrowLeft') {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
      } else if (e.key === 'ArrowRight') {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      } else if (e.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen, images.length]);

   useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isModalOpen]);

  if (!images || images.length === 0) return null;

  const handleImageClick = (index: number) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleClose = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;

    if (deltaX > 50) {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    } else if (deltaX < -50) {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }

    touchStartX.current = null;
  };

  return (
    <div className="review-image-wrapper">
      <div className="image-stack" onClick={() => handleImageClick(0)}>
        <img src={images[0].media_url} className="stacked-image" />
        {images.length > 1 && <span className="overlay">+{images.length}</span>}
      </div>

      {isModalOpen && (
        <div
          className="image-modal"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="overlay-bg" onClick={handleClose} />
          <div className="modal-inner">
            <button className="close-btn" onClick={handleClose}>×</button>
            <img src={images[currentIndex].media_url} className="modal-image" />
            <div className="modal-footer">
              <span className="img-counter">{currentIndex + 1}/{images.length}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewImageViewer;
